// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabs_27b8e2ab {
  position: relative;
}
.tabs__scroll_27b8e2ab {
  height: 100%;
  scrollbar-width: none;
  overflow: auto;
}
.tabs__list_27b8e2ab {
  display: flex;
  width: max-content;
  gap: 1.334rem;
  height: 3.334rem;
}
.tabs__list_vertical_27b8e2ab {
  width: 100%;
}
.tabs__list_vertical_27b8e2ab .tabs__link_27b8e2ab {
  min-height: 3rem;
}
.tabs__list_vertical_27b8e2ab:not(.tabs_content_27b8e2ab) {
  flex-direction: column;
  height: auto;
  gap: 0;
}
.tabs__item_27b8e2ab {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -khtml-user-select: none;
  -ms-user-select: none;
}
.tabs_27b8e2ab > .tabs__list_27b8e2ab > .tabs__item_27b8e2ab:only-child {
  cursor: default;
}
.tabs__item_27b8e2ab.tabs__item_disabled_27b8e2ab {
  cursor: default;
}
.tabs__item_active_27b8e2ab .tabs__link_27b8e2ab {
  font-weight: 600;
}
.tabs__item_active_27b8e2ab .tabs__link_27b8e2ab:hover {
  background: none;
  color: #11304d;
}
.tabs__item_active_27b8e2ab .tabs__link_27b8e2ab::before {
  left: 0;
  width: 100%;
}
.tabs__item_disabled_27b8e2ab .tabs__link_27b8e2ab {
  cursor: default;
  color: #c1c8cd !important;
  background: none;
}
.tabs__item_disabled_27b8e2ab:focus .tabs__link_27b8e2ab,
.tabs__item_disabled_27b8e2ab:active .tabs__link_27b8e2ab,
.tabs__item_disabled_27b8e2ab:hover .tabs__link_27b8e2ab {
  cursor: default;
  color: #c1c8cd !important;
  background: none;
}
.tabs__item_dropdown_27b8e2ab .dropdown-mix_27b8e2ab {
  height: 100%;
}
.tabs__icon_27b8e2ab {
  height: 100%;
  position: relative;
  display: flex;
  align-self: stretch;
  align-items: center;
  margin-right: 0.667rem;
  line-height: 1;
  white-space: nowrap;
  font-weight: 400;
}
.tabs__icon_right_27b8e2ab {
  margin-right: 0;
  margin-left: 0.667rem;
}
.tabs__link_27b8e2ab {
  position: relative;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  height: 100%;
  padding: 0.667rem;
  display: flex;
  align-items: center;
  scroll-margin-inline: 2.667rem;
}
.tabs__link_27b8e2ab.tabs__link_27b8e2ab {
  text-decoration: none;
  color: #11304d;
  outline: none;
  box-shadow: none;
}
.tabs__link_with-adornment_27b8e2ab {
  padding-right: 0;
}
.tabs__link_no-ellipsis_27b8e2ab {
  white-space: normal;
}
.tabs__link_27b8e2ab:hover {
  background: #eaedef;
}
.tabs__link_27b8e2ab:focus-visible::after {
  content: "";
  position: absolute;
  inset: 0;
  box-shadow: 0 0 0 2px #1d5080 inset;
  pointer-events: none;
}
.tabs__link_27b8e2ab::before {
  content: '';
  position: absolute;
  width: 0;
  left: 50%;
  right: auto;
  bottom: 0;
  height: 4px;
  background-color: #267479;
}
.tabs__adornment_27b8e2ab {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
  padding-right: 0.667rem;
}
.tabs__caption_27b8e2ab {
  line-height: 1.667rem;
  pointer-events: none;
  max-width: 100%;
}
.tabs__link_27b8e2ab:not(.tabs__link_no-ellipsis_27b8e2ab) .tabs__caption_27b8e2ab {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}
.tabs__image_27b8e2ab {
  width: 2rem;
  margin-right: 0.667rem;
}
.tabs__separator_27b8e2ab {
  width: 0;
  flex-shrink: 0;
  border-left: 0.084rem solid #dce1e5;
}
.tabs__separator_secondary_27b8e2ab {
  margin: 0.667rem 0;
  background: #84919b;
  border-left: thin solid #84919b;
}
.tabs_s-level_27b8e2ab .tabs__list_27b8e2ab {
  height: 4rem;
  gap: 0;
}
.tabs_s-level_27b8e2ab .tabs__link_27b8e2ab {
  font-weight: 600;
  margin: 0;
  padding: 0 1.334rem;
}
.tabs_s-level_27b8e2ab .tabs__link_27b8e2ab:hover {
  background: #eaedef;
}
.tabs_s-level_27b8e2ab .tabs__item_active_27b8e2ab .tabs__link_27b8e2ab {
  background: #dce1e5;
}
.tabs_s-level_27b8e2ab .tabs__item_active_27b8e2ab .tabs__link_27b8e2ab::before {
  width: 0;
}
.tabs_s-level_27b8e2ab .tabs__slide-arrow_27b8e2ab.slide-arrow_left {
  background: linear-gradient(to right, #f8f9fa 0%, #f8f9fa 30%, rgba(248,249,250,0) 100%);
}
.tabs_s-level_27b8e2ab .tabs__slide-arrow_27b8e2ab.slide-arrow_right {
  background: linear-gradient(to right, rgba(248,249,250,0) 0%, #f8f9fa 70%, #f8f9fa 100%);
}
.tabs_th-level_27b8e2ab .tabs__list_27b8e2ab {
  gap: 0;
  padding: 0;
}
.tabs_th-level_27b8e2ab .tabs__link_27b8e2ab {
  font-weight: 600;
  margin: 0;
  padding: 0 1.334rem;
}
.tabs_th-level_27b8e2ab .tabs__link_27b8e2ab:hover {
  background: #eaedef;
}
.tabs_th-level_27b8e2ab .tabs__item_active_27b8e2ab .tabs__link_27b8e2ab {
  background: #c1c8cd;
}
.tabs_th-level_27b8e2ab .tabs__item_active_27b8e2ab .tabs__link_27b8e2ab::before {
  width: 0;
}
.tabs_th-level_27b8e2ab .tabs__slide-arrow_27b8e2ab.slide-arrow_left {
  background: linear-gradient(to right, #dce1e5 0%, #dce1e5 30%, rgba(220,225,229,0) 100%);
}
.tabs_th-level_27b8e2ab .tabs__slide-arrow_27b8e2ab.slide-arrow_right {
  background: linear-gradient(to right, rgba(220,225,229,0) 0%, #dce1e5 70%, #dce1e5 100%);
}
.tabs_content_27b8e2ab .tabs__list_27b8e2ab {
  flex-direction: column;
  height: auto;
  gap: 0;
  padding: 0;
}
.tabs_content_27b8e2ab .tabs__link_27b8e2ab {
  padding: 0.667rem 1.334rem;
  margin: 0;
}
.tabs_content_27b8e2ab .tabs__link_27b8e2ab::before {
  left: 0;
  top: 100%;
  margin-top: -1rem;
  height: 0;
  width: 0.167rem;
  background-color: #11304d;
}
.tabs_content_27b8e2ab .tabs__link_27b8e2ab:hover {
  color: #11304d;
  background: #eaedef;
}
.tabs_content_27b8e2ab .tabs__item_27b8e2ab {
  height: auto;
}
.tabs_content_27b8e2ab .tabs__item_active_27b8e2ab {
  font-weight: 400;
}
.tabs_content_27b8e2ab .tabs__item_active_27b8e2ab .tabs__link_27b8e2ab:hover {
  background: none;
}
.tabs_content_27b8e2ab .tabs__item_active_27b8e2ab .tabs__link_27b8e2ab::before {
  top: 0;
  bottom: 0;
  height: 100%;
  margin: 0;
}
.tabs_content_27b8e2ab .tabs__item_disabled_27b8e2ab .tabs__link_27b8e2ab {
  color: #c1c8cd;
}
.tabs_content_27b8e2ab .tabs__item_disabled_27b8e2ab:focus .tabs__link_27b8e2ab,
.tabs_content_27b8e2ab .tabs__item_disabled_27b8e2ab:active .tabs__link_27b8e2ab,
.tabs_content_27b8e2ab .tabs__item_disabled_27b8e2ab:hover .tabs__link_27b8e2ab {
  color: #c1c8cd;
}
.tabs_content_27b8e2ab .tabs__nested_27b8e2ab {
  padding: 0.334rem 0 0.334rem 1.334rem;
}
.tabs_content_27b8e2ab .tabs__nested_27b8e2ab:empty {
  padding: 0;
}
.tabs__badge_27b8e2ab {
  padding-right: 0.667rem;
  padding-left: 0.334rem;
  color: #267479;
}
.tabs_sidebar_27b8e2ab .tabs_sidebar__item_27b8e2ab.tabs__item_27b8e2ab .tabs__link_27b8e2ab {
  padding: 0.667rem 0.667rem 0.667rem 2rem;
}
.tabs_sidebar_27b8e2ab .tabs_sidebar__item_27b8e2ab.tabs__item_27b8e2ab .tabs__link_27b8e2ab::before {
  display: none;
}
.tabs_sidebar_27b8e2ab .tabs_sidebar__item_27b8e2ab.tabs__item_27b8e2ab:not(.tabs__item_active_27b8e2ab) .tabs__link_27b8e2ab:hover {
  background-color: #eaedef;
  color: #11304d;
}
.tabs_sidebar_27b8e2ab .tabs_sidebar__item_27b8e2ab.tabs__item_active_27b8e2ab .tabs__link_27b8e2ab {
  background-color: #dce1e5;
}
.tabs_sidebar_27b8e2ab .tabs_sidebar__item_highlighted_27b8e2ab {
  font-weight: 600;
  background-color: #f8f9fa;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabs": `tabs_27b8e2ab`,
	"tabs__scroll": `tabs__scroll_27b8e2ab`,
	"tabs__list": `tabs__list_27b8e2ab`,
	"tabs__list_vertical": `tabs__list_vertical_27b8e2ab`,
	"tabs__link": `tabs__link_27b8e2ab`,
	"tabs_content": `tabs_content_27b8e2ab`,
	"tabs__item": `tabs__item_27b8e2ab`,
	"tabs__item_disabled": `tabs__item_disabled_27b8e2ab`,
	"tabs__item_active": `tabs__item_active_27b8e2ab`,
	"tabs__item_dropdown": `tabs__item_dropdown_27b8e2ab`,
	"dropdown-mix": `dropdown-mix_27b8e2ab`,
	"tabs__icon": `tabs__icon_27b8e2ab`,
	"tabs__icon_right": `tabs__icon_right_27b8e2ab`,
	"tabs__link_with-adornment": `tabs__link_with-adornment_27b8e2ab`,
	"tabs__link_no-ellipsis": `tabs__link_no-ellipsis_27b8e2ab`,
	"tabs__adornment": `tabs__adornment_27b8e2ab`,
	"tabs__caption": `tabs__caption_27b8e2ab`,
	"tabs__image": `tabs__image_27b8e2ab`,
	"tabs__separator": `tabs__separator_27b8e2ab`,
	"tabs__separator_secondary": `tabs__separator_secondary_27b8e2ab`,
	"tabs_s-level": `tabs_s-level_27b8e2ab`,
	"tabs__slide-arrow": `tabs__slide-arrow_27b8e2ab`,
	"tabs_th-level": `tabs_th-level_27b8e2ab`,
	"tabs__nested": `tabs__nested_27b8e2ab`,
	"tabs__badge": `tabs__badge_27b8e2ab`,
	"tabs_sidebar": `tabs_sidebar_27b8e2ab`,
	"tabs_sidebar__item": `tabs_sidebar__item_27b8e2ab`,
	"tabs_sidebar__item_highlighted": `tabs_sidebar__item_highlighted_27b8e2ab`
};
export default ___CSS_LOADER_EXPORT___;
